function getAdsData(adUrl) {
  return fetch(adUrl, {
    method: 'GET'
  }).then(function (response) {
    if (response.ok) {
      return response;
    }

    var error = new Error('Network response was not ok.');
    error.response = response;
    throw error;
  }).then(function (response) {
    return response.text();
  }).then(function (response) {
    return response && JSON.parse(response);
  });
}

export default getAdsData;